import { en } from './translations/en';
import { RecursiveKeyOf, getValueByPath, interpolate } from './utils';

const translations = {
  en,
};

type AvailableLanguages = keyof typeof translations;
type TranslationSchema = typeof en;
type TranslationKey = RecursiveKeyOf<TranslationSchema>;

let currentLang: AvailableLanguages = 'en';

export function setLanguage(lang: AvailableLanguages) {
  if (translations[lang]) {
    currentLang = lang;
  } else {
    console.warn(`[i18n] Language '${lang}' not available. Falling back to '${currentLang}'`);
  }
}

export function T(key: TranslationKey, params?: Record<string, string | number>): string {
  const langPack = translations[currentLang] || translations.en;
  const value = getValueByPath(langPack, key) || getValueByPath(translations.en, key);

  if (!value) {
    console.warn(`[i18n] Missing translation for key '${key}'`);
    return key;
  }

  if (params) {
    return interpolate(value, params);
  }

  return value;
}
